module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header",
    staticStyle: {
      "background-color": "black"
    }
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": "/"
    }
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_c('b', [_c('img', {
    attrs: {
      "src": "static/img/REKFIXLOGOSMALL.png",
      "alt": "User Image"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg",
    staticStyle: {
      "height": "1px"
    }
  }, [_c('b', [_c('img', {
    attrs: {
      "src": "static/img/REKFIXLOGOSMALL.png",
      "alt": "User Image"
    }
  })])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top"
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "id": "main-sidebar",
      "href": "#",
      "data-toggle": "offcanvas",
      "data-target": "collapse",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleToggle()
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu",
    attrs: {
      "id": "Custom-menu"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-home",
    staticStyle: {
      "color": "blue"
    }
  }, [_c('b', {
    staticStyle: {
      "padding": "4px",
      "color": "blue"
    }
  }, [_vm._v("Home")])])])], 1)], 1)])], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-email"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-menu-devin"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have no new Messages")])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "size": "small"
    }
  }, [_c('i', {
    staticClass: "ti-bell"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('ul', {
    staticClass: "dropdown-menu-devin"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have no new notifications")])])])], 1)], 1), _vm._v(" "), _c('li', [_c('el-dropdown', {
    staticClass: "header-dropdown-devin",
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  })])], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-left-search"
  }, [_c('form', {
    attrs: {
      "id": "demo-2"
    }
  }, [_c('input', {
    staticClass: "devin-search",
    attrs: {
      "type": "search"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f2e4080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Header.vue
// module id = 1289
// module chunks = 2